<template>
	<div
		:class="['select-box', addClass, { open: isOpen }]"
		v-if="options && options.length > 0"
	>
		<div
			:class="['select-box__container', { active: isOpen }]"
			@click="toggleUi"
		>
			<button
				class="select-box__selected"
				type="button"
				:title="getSelectedObj[valueKey]"
			>
				{{ getSelectedObj[valueKey] }}
			</button>
			<ul class="select-box__list" v-if="isOpen">
				<template v-for="opt in options">
					<li v-if="opt[idKey] !== hideItemId" :key="opt[idKey]">
						<button
							class="select-box__list__btn"
							type="button"
							@click="selecting(opt[idKey])"
							:title="opt[valueKey]"
						>
							{{ opt[valueKey] }}
						</button>
					</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		name: 'SelectBox',
		props: {
			idKey: {
				type: String,
				default: 'id',
			},
			valueKey: {
				type: String,
				default: 'text',
			},
			options: Array,
			addClass: String,
			val: [Number, String],
			hideItemId: [Number, String],
		},
		data() {
			return {
				isOpen: false,
			};
		},
		computed: {
			...mapState({
				isMobile: state => state.env.isMobile,
			}),
			getSelectedObj() {
				return this.options.find(item => item[this.idKey] === this.val);
			},
		},
		methods: {
			toggleUi(bool) {
				this.isOpen = typeof bool === 'boolean' ? bool : !this.isOpen;
			},
			selecting(id) {
				this.$emit('changing', id);
			},
		},
	};
</script>

<style lang="scss" scoped>
	DIV.select-box {
		cursor: pointer;
		overflow: hidden;
		z-index: 50;
		position: relative;
		height: 36px;

		&.open {
			overflow: visible;
		}

		.select-box__container {
			overflow: hidden;
			position: relative;
			width: 100%;
			height: auto;
			border: solid 1px #dfe6ee;
			border-radius: 4px;
			background-color: #fff;

			&:after {
				content: '';
				display: block;
				position: absolute;
				width: 8px;
				height: 8px;
				top: 12px;
				right: 12px;
				border: solid 2px #dfe6ee;
				border-left: 0;
				border-top: 0;
				border-radius: 2px;
				transform: rotate(45deg);
			}

			&:hover {
				border-color: #b0bac5;

				&:after {
					border-color: #b0bac5;
				}
			}

			&.active {
				border-color: #0099fa;

				&:after {
					border-color: #0099fa;
				}
			}
		}

		.select-box__selected {
			display: block;
			width: 100%;
			height: 34px;
			padding: 0 36px 0 12px;
			vertical-align: top;
			line-height: 34px;
			text-align: left;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			color: #222;
			font-size: 0.875rem;
			font-weight: bold;
		}

		.select-box__list {
			max-height: 162px;
			overflow-y: auto;
		}

		.select-box__list__btn {
			display: block;
			width: 100%;
			height: 36px;
			vertical-align: top;
			line-height: 36px;
			color: #222;
			font-size: 0.875rem;
			text-align: left;
			padding: 0 12px;
			overflow: hidden;
			text-overflow: ellipsis;

			&:hover {
				font-weight: bold;
				padding: 0 11px;
				background-color: #ecf2f8;
			}
		}
	}
</style>
